import React from 'react';
import { SmartWearableFilter as SmartWearableFilterUI } from 'decentraland-ui/dist/components/SmartWearableFilter';
import { t } from '../../modules/translation/utils';
export const SmartWearableFilter = (props) => {
    const i18n = {
        title: t('@dapps.smart_wearables_filter.title'),
        selected: t('@dapps.smart_wearables_filter.selected')
    };
    return React.createElement(SmartWearableFilterUI, { i18n: i18n, ...props });
};
//# sourceMappingURL=SmartWearableFilter.js.map